import {updateFactory} from '@modifi/redux'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const client = getAuthenticatedAdminAresClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.modules?.tagTransaction,
  actionNamePrefix: `transactions/tag-transaction`,
  submitRequest:
    (a, params) =>
    async (dispatch): Promise<void> => {
      const {transactionId, changes} = params
      dispatch(a.pendingAction())
      try {
        await client.BankTransactions.tag({
          transactionId,
          body: changes,
        }).then(res => res.data())
      } catch (e) {
        dispatch(a.errorAction(e))
        throw e
      }
      dispatch(a.successAction())
    },
})

export default reducer

export const {
  selectUpdateErrorMessage: selectTagErrorMessage,
  selectUpdatePending: selectTagPending,
} = selectors

export const {aSubmit: aTagTransaction, aReset: aCleanupTag} = actions
